import Vue from 'vue'
import Router from 'vue-router'
import Hotel from './views/Hotel/Index.vue'
import store from '@/store'
import { messages } from '@/i18n'
import dayjs from 'dayjs'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior (to, from, savedPosition) {
    if (to.name !== from.name || !from) {
      return { x: 0, y: 0 }
    }
  },
  routes: [
    {
      path: '/',
      name: 'Welcome',
      redirect: to => {
        window.location = process.env.VUE_APP_OWLNEST_ROOT
      }
    },
    {
      path: '/:hotelId',
      name: 'Hotel',
      component: Hotel,
      meta: {
        title: '訂房',
        titleI18n: 'bookRoom'
      }
    },
    {
      path: '/:hotelId/addon',
      name: 'Addon',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "Addon" */ './views/Addon/Index.vue')
    },
    {
      path: '/:hotelId/payment',
      name: 'Payment',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "Payment" */ './views/Payment/Index.vue'),
      meta: {
        footerMargin: false
      }
    },
    {
      path: '/:hotelId/payment-callback',
      name: 'PaymentCallback',
      component: () => import(/* webpackChunkName: "PaymentCallback" */ './views/PaymentCallback/Index.vue'),
      meta: {
        cover: false
      }
    },
    {
      path: '/:hotelId/agent-pay/:orderSerial',
      name: 'AgentPay',
      component: () => import(/* webpackChunkName: "AgentPay" */ './views/AgentPay/Index.vue'),
      meta: {
        cover: false
      }
    },
    {
      path: '/:hotelId/complete/:orderSerial',
      name: 'Complete',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "Complete" */ './views/Complete/Index.vue'),
      meta: {
        cover: false
      }
    }
  ]
})

function hasQueryParams (route) {
  return !!Object.keys(route.query).length
}

router.beforeEach((to, from, next) => {
  const today = dayjs(store.state.hotel.todayByHotelTimeZone).format('YYYY-MM-DD')
  const isBefore = dayjs(to.query.start).isBefore(today) || dayjs(to.query.end).isBefore(today)
  if (typeof to.params.hotelId !== 'undefined' && store.state.hotelId !== to.params.hotelId) {
    // test: 779564dc-b308-4605-955c-4b2efeab87e2
    store.commit('SET_HOTEL_ID', to.params.hotelId)
  }

  // [OW-4948] inherit query from previous route (should run before lang redirect)
  if (!hasQueryParams(to) && hasQueryParams(from) && !isBefore) {
    next({
      ...to,
      query: {
        ...from.query
      }
    })
    return
  } else if (hasQueryParams(to) && !hasQueryParams(from) && isBefore) {
    next({
      ...to,
      query: {
        ...to.query,
        start: today,
        end: dayjs(today).add(1, 'day').format('YYYY-MM-DD')
      },
      replace: true
    })
    return
  }

  // set lang query — priority: ?lang > alias > persisted > hotel default
  const queryLang = to.query.lang
  const hotelLang = store.state.hotel.hotel.language
  const supportLangs = Object.keys(messages)

  const aliasList = store.state.hotelAliasList
  const aliasLangMap = { zh_tw: 'zh_TW', en: 'en', ja: 'ja' }
  const matchedAlias = Object.entries(aliasList).find(([, alias]) => alias === to.params.hotelId)
  const aliasLang = matchedAlias ? aliasLangMap[matchedAlias[0]] : null

  const persistedLang = store.state.selectedLanguage

  const finalLang = [queryLang, aliasLang, persistedLang, hotelLang].find(lang => supportLangs.includes(lang)) || 'zh_TW'
  store.commit('SET_LANGUAGE', finalLang)

  if (to.query.lang !== finalLang) {
    next({
      ...to,
      query: {
        ...to.query,
        lang: finalLang
      },
      replace: true
    })
    return
  }
  //

  // custom domain redirect
  const hotelCustomDomain = store.state.hotelCustomDomain

  if (hotelCustomDomain && location.hostname !== hotelCustomDomain) {
    let pathname = location.pathname.split('/')
    pathname.splice(0, 2)
    location.href = `${location.protocol}//${hotelCustomDomain}/booking/${pathname.join('/')}${location.search}`
    return
  }

  next()
})

export default router
